import React from "react";
import { FiColumns, FiEdit3, FiSave, FiAlertCircle } from "react-icons/fi";

export default function ComparisonStep({
  NavigationButtons,
  setComparisonEditMode,
  comparisonEditMode,
  apiInProgress,
  comparisonRows,
  handleSaveComparisonEdits,
  comparisonDisplayRowsOrdered,
  comparisonSourceRowsForDisplay,
  comparisonVaultRowsForDisplay,
  renderDocumentStyleSurface,
  renderComparisonEditableSurface,
  comparisonSaved,
}) {
  return (
    <div className="wizard-step-content comparison-step">
      <div className="step-header-with-nav">
        <div className="step-header-left">
          <div className="step-icon-wrapper">
            <FiColumns className="step-icon" />
          </div>
          <div className="step-header-text">
            <h2 className="step-title">Compare and Review</h2>
            <p className="step-subtitle">Review and edit final Vault content while preserving original row and column format</p>
          </div>
        </div>
        <NavigationButtons
          prependActions={(
            <>
              <button
                className="step-nav-btn secondary"
                onClick={() => setComparisonEditMode(true)}
                disabled={comparisonEditMode || apiInProgress || comparisonRows.length === 0}
                type="button"
              >
                <FiEdit3 /> Edit
              </button>
              <button
                className="step-nav-btn primary"
                onClick={handleSaveComparisonEdits}
                disabled={!comparisonEditMode || apiInProgress || comparisonRows.length === 0}
                type="button"
              >
                <FiSave /> Save
              </button>
            </>
          )}
        />
      </div>

      <div className="form-section">
        {comparisonDisplayRowsOrdered.length === 0 ? (
          <div className="reference-note" role="status">
            <FiAlertCircle className="note-icon" />
            <p>No comparison rows found. Complete Vocabulary generation first.</p>
          </div>
        ) : (
          <div className="process-document-compare-scroll">
            <div className="process-document-compare-grid">
              <div className="process-document-panel">
                <div className="process-document-panel-title">Veeva Content - Original</div>
                {renderDocumentStyleSurface(comparisonSourceRowsForDisplay, "comparison-source")}
              </div>
              <div className="process-document-panel">
                <div className="process-document-panel-title">Vault Content - Final</div>
                {renderComparisonEditableSurface(comparisonVaultRowsForDisplay, "comparison-vault")}
              </div>
            </div>
          </div>
        )}
        <div className="vocabulary-summary">
          <span>
            {comparisonEditMode
              ? "Edit mode is active. Click Save to persist changes."
              : comparisonSaved
                ? "Saved comparison content will be used for document output."
                : "Unsaved changes are ignored for output. Click Edit and Save to persist."}
          </span>
        </div>
      </div>
    </div>
  );
}
